module.exports = __webpack_public_path__ + "static/media/montreal.21f54393.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/montreal.jpeg
// module id = 552
// module chunks = 0